import { DatePipe } from '@angular/common';
import { Component, computed, Injector, input, OnDestroy, OnInit, output, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { takeWhile } from 'rxjs';
import { AppointmentPickerComponent } from '../../../../../../../shared/components/appointment-picker/appointment-picker.component';
import { templateDrivenFormsViewProviders } from '../../../../../../../shared/directives/form.directive';
import { TimeFormatPipe } from '../../../../../../../shared/pipes/time-format.pipe';
import { TimeSlotFormatPipe } from '../../../../../../../shared/pipes/timeslot-format.pipe';
import { OrbitFormClaimService } from '../../../../services/orbit-form-claim.service';
import { PutServiceOptionResponse } from '../../../../types/put-service-option-response';
import { getErrorsFromSubmission } from '../../pipes/error-subscription';

type DateString = `${string}-${string}-${string}`;

@Component({
  selector: 'app-book-collection',
  imports: [FormsModule, AppointmentPickerComponent, DatePipe],
  providers: [TimeSlotFormatPipe, TimeFormatPipe],
  templateUrl: './book-collection.component.html',
  styleUrl: './book-collection.component.scss',
  viewProviders: [templateDrivenFormsViewProviders],
  standalone: true,
})
export class BookCollectionComponent implements OnInit, OnDestroy {
  formValue = input<Record<string, any>>({});
  slotValue = signal<any>(undefined);
  slotsToExclude = signal<any[]>([]);
  private _destroyed = false;
  formSubmitted = input.required<boolean>();
  formValid = output<boolean>();
  valid = signal(false);

  private viewModel = computed(() => {
    const latestStep = this.orbitFormClaimService.state.latestStep as PutServiceOptionResponse; // mockBooking as any as PutServiceOptionResponse; //;

    const formattedDates = (latestStep?.availabilityData ?? []).reduce((a, b) => {
      const i = b.slots[0];
      return {
        ...a,
        [b.date]: [
          {
            available: i.available,
            capacity: 1,
            date: b.date,
            endTime: i.endTime,
            startTime: i.startTime,
            bringForwardDays: undefined,
            id: i.id ?? i.identifier,
          },
        ],
      };
    }, {});

    const formattedDatesObjects = {
      daysWithSlots: Object.keys(formattedDates) || [],
      earliestSlot: Object.keys(formattedDates)[0] || '',
      slotsByDate: formattedDates ?? {},
    };
    const serviceOption = this.orbitFormClaimService.storedValue?.['service-options']?.['option'];
    const isGameReplacement = serviceOption?.serviceOptionLabel.toLowerCase().includes('game exchange');

    return {
      bookingDates: formattedDatesObjects,
      availabilityStartDate: latestStep?.availabilityStartDate as DateString | undefined,
      formValue: this.formValue(),
      slotsToExclude: this.slotsToExclude(),
      submittingResource: this.orbitFormClaimService.formSubmission,
      formSubmitted: this.formSubmitted(),
      formValid: this.valid(),
      isGameReplacement,
      planNumber: this.orbitFormClaimService.state.claimData.bundle.planNumber,
    };
  });

  selectedSlot: any;
  get vm() {
    return this.viewModel();
  }
  constructor(
    private readonly orbitFormClaimService: OrbitFormClaimService,
    private readonly injector: Injector
  ) {}

  ngOnDestroy(): void {
    this._destroyed = true;
  }

  ngOnInit(): void {
    this.handleFormValidation();
    this.handleAPIErrors();
  }

  handleFormValidation(): void {
    toObservable(this.formValue, { injector: this.injector })
      .pipe(takeWhile(() => !this._destroyed))
      .subscribe((v) => {
        if (v) {
          const isValid = v['collection-date'] != undefined;
          this.formValid.emit(isValid);
          this.valid.set(isValid);
        }
      });
  }

  handleAPIErrors(): void {
    getErrorsFromSubmission(this.vm.submittingResource, this.injector, (attempts, error) => {
      console.error(error);
    });
  }
}
